import { Component, createApp, CreateAppFunction, App, h } from 'vue';
import Root from '@/components/root-component/root-component.vue';
import { createPinia } from 'pinia';
import ElementPlus from 'element-plus';
import router from '@/router/router';
import wrapper from 'vue3-webcomponent-wrapper';

export const initApp = async (): Promise<void> => {
  if (window.customElements.get(CUSTOM_ELEMENT_TAG)) {
    return;
  }

  try {
    const createAppWrapper: CreateAppFunction<Element> = (component: Component): App =>
      createApp(component)
        .use(ElementPlus)
        .use(createPinia())
        .use(router);

    const webComponent = wrapper(Root, createAppWrapper, h);
    window.customElements.define(CUSTOM_ELEMENT_TAG, webComponent);

    await import('@/styles/common.scss');
  } catch (error) {
    console.error('Error during app initialization:', error);
  }
};
